import React, { useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { isNullOrWhitespace } from 'js/utils/string';
import { useQuery } from 'js/hooks/useQuery';
import { SCHEMAS } from 'js/api';
import {
  listCohorts as listUserGroupMembers,
  createCohort as createUserGroupMemberCohort,
  updateCohort as updateUserGroupMemberCohort,
  deleteCohort as deleteUserGroupMemberCohort,
} from 'js/actions/user-group-member-actions';
import UserGroupMembers from '../components/UserGroup/UserGroupMembers';

function UserGroupMembersContainer({
  userGroup,
  listUserGroupMembers,
  createUserGroupMemberCohort,
  updateUserGroupMemberCohort,
  deleteUserGroupMemberCohort,
}) {
  const { userGroupId } = useParams();

  const listMembers = useCallback(
    (queryId) => listUserGroupMembers(userGroupId, queryId),
    [userGroupId, listUserGroupMembers]
  );

  const {
    result: members,
    isLoading,
    hasLoaded,
    refresh,
  } = useQuery({
    queryId: `userGroupMembers-${userGroupId}`,
    query: listMembers,
    schema: SCHEMAS.USER_GROUP_MEMBER_COHORT_ARRAY,
  });

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleAddMember = useCallback(
    async (member) => {
      const memberCohort = {
        cohort: isNullOrWhitespace(member.cohort) ? null : member.cohort,
        user_group_member: {
          name: member.name,
          email: member.email,
          title: isNullOrWhitespace(member.title) ? null : member.title,
        },
      };

      const result = await createUserGroupMemberCohort(
        userGroupId,
        memberCohort
      );
      refresh();
      return result;
    },
    [userGroupId, createUserGroupMemberCohort, refresh]
  );

  const handleUpdateMember = useCallback(
    async (member, updateValues) => {
      const result = await updateUserGroupMemberCohort(userGroupId, {
        ...member,
        user_group_member: {
          ...member.user_group_member,
          name: updateValues.name,
          title: updateValues.title,
        },
        cohort: updateValues.cohort,
      });
      await refresh();
      return result;
    },
    [userGroupId, updateUserGroupMemberCohort, refresh]
  );

  const handleRemoveMember = useCallback(
    async (member) => {
      await deleteUserGroupMemberCohort(
        userGroupId,
        member.user_group_member_id
      );
      return refresh();
    },
    [userGroupId, deleteUserGroupMemberCohort, refresh]
  );

  return (
    <UserGroupMembers
      userGroup={userGroup}
      onAddMember={handleAddMember}
      onUpdateMember={handleUpdateMember}
      onRemoveMember={handleRemoveMember}
      members={members}
      isLoading={isLoading}
      hasLoaded={hasLoaded}
    />
  );
}

export default connect(null, {
  listUserGroupMembers,
  createUserGroupMemberCohort,
  updateUserGroupMemberCohort,
  deleteUserGroupMemberCohort,
})(UserGroupMembersContainer);
